var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBvalorSlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Camada_1",
    viewBox: "30.39 0 74.53 172.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #c59913;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.92,66.96v51.77c-5.73,17.31-11.43,34.62-17.15,51.93-.13.38-.28.74-.55,1.44C68.22,114.57,49.33,57.37,30.39.03h7.09c2.89,0,5.79.06,8.68-.03,1.13-.04,1.55.38,1.88,1.39,7.26,22.12,14.55,44.24,21.83,66.35,5.37,16.27,10.74,32.54,16.1,48.81.39,1.17.76,2.35,1.15,3.58.51-.24.49-.71.6-1.05,5.74-17.37,11.47-34.75,17.2-52.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBvalorSlogo);
export default __webpack_public_path__ + "static/media/BVALOR_slogo.8d5dcc148e7f42c41b5f42aff7216164.svg";
export { ForwardRef as ReactComponent };